export { default } from './ButtonBase';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/ButtonBase/index.js
// module id = 80
// module chunks = 2